interface ChainConfig {
  [chainId: string]: {
    name: string
    clientId: string
    contracts: string[]
  }
}

const chainConfig: ChainConfig = {
  '1': {
    name: 'ethereum',
    clientId: '414acb93-dcd1-4937-9fa5-a417fe65e85e',
    contracts: ['0x1B41d54B3F8de13d58102c50D7431Fd6Aa1a2c48'.toLowerCase()],
  },
  '5': {
    name: 'ethereum', //goerli
    clientId: '63c9c408-2c8f-4029-a812-bdeab12d2810',
    contracts: [],
  },
  '42170': {
    name: 'arbitrumnova',
    clientId: '07b804fa-67fe-4554-8f00-f6c13c227eaf',
    contracts: [
      '0x05E986e9EF944ffd425eD07aBc2f39E35821D1e0'.toLowerCase(),
      '0xa2494e5FEE63b8C634c8aCF4cB4d1322fc71a0af'.toLowerCase(),
    ],
  },
  '70700': {
    name: 'apex',
    clientId: 'a75ac3e9-4dbd-4b9f-b0c6-1922e210417a',
    contracts: [
      '0x3c5094389b81aa0c5445b60d20d505535d549af1'.toLowerCase(), // Ships
      '0xaf57145e0c09a75ca4a2dc65ac80c91920e537ce'.toLowerCase(), // Game Items
    ],
  },
  '70701': {
    name: 'boss',
    clientId: 'a1234182-e8c4-47d5-8845-72c313ada346',
    contracts: [
      '0xCE4C0930087880a91b301a4Bf803bE40bEc45417'.toLowerCase(), // Ships
      '0x87A9Ebf7cB0DE5c3ebc13E59006F58e553980d9d'.toLowerCase(), // Game Items
    ],
  },
  '421613': {
    name: 'arbitrum', //goerli
    clientId: '6e9cda21-952d-423b-b6a8-dfcf0cbbb08e',
    contracts: [],
  },
}

interface CrossmintArgs {
  clientId: string
}

export const getCrossmintConfig = (
  chainId: number,
  recipient?: string,
  contract?: string
): CrossmintArgs | null => {
  const config = chainConfig[String(chainId)]

  if (
    contract === undefined ||
    recipient === undefined ||
    config === undefined
  ) {
    return null
  }

  const contracts = config.contracts
  if (!contracts || !contracts.includes(contract.toLowerCase())) {
    return null
  }
  return {
    clientId: config.clientId,
  }
}


export const CROSSMINT_USD_LIMIT = 4_000
